import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import loadable from '@loadable/component';
import { Context } from '../../context/AppContext';

const ModalLoadable = loadable(() =>
  import(/* webpackChunkName: "Modal" */ './ModalLoadable')
);

const Modal = ({
  children,
  name,
  animationDuration = 300,
  onClickOutside,
  className,
  animation,
  fullScreen,
  containerStyle,
}) => {
  const {
    modal: { modals },
  } = useContext(Context);
  const { show } = modals[name] || {};
  const [inDom, setInDom] = useState(false);

  useEffect(() => {
    let timeout;
    if (show) {
      setInDom(true);
    } else {
      timeout = setTimeout(() => setInDom(false), animationDuration - 50);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [show, animationDuration]);

  useEffect(() => {
    return () => {};
  }, []);

  return (
    inDom &&
    createPortal(
      <ModalLoadable
        show={show}
        name={name}
        animation={animation}
        animationDuration={animationDuration}
        onClickOutside={onClickOutside}
        className={className}
        fullScreen={fullScreen}
        containerStyle={containerStyle}
      >
        {children}
      </ModalLoadable>,
      document.body
    )
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  onClickOutside: PropTypes.func,
  show: PropTypes.bool,
  className: PropTypes.string,
  animation: PropTypes.string,
  containerStyle: PropTypes.shape({}),
};

Modal.defaultProps = {
  children: undefined,
  onClickOutside: undefined,
  show: false,
  className: undefined,
  animation: undefined,
  containerStyle: {},
};

export default Modal;
